import { createSelector } from 'reselect'
// import { List } from 'immutable'

const employeeSelector = state => state.get('employee')

export const getIsFetching = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeCreate.isFetching
    || employee.employeeEdit.isFetching
    || employee.employeeDeactivate.isFetching
    || employee.employeeList.isFetching
    || employee.employeeGet.isFetching
    || employee.employeeExport.isFetching
    || employee.employeeImport.isFetching
    || employee.employeeFavorite.isFetching
  }
)
export const getCreateUserData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeCreate
  }
)
export const getEditUserData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeEdit
  }
)
export const getEditUserProfile = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeEditProfile
  }
)
export const getDeactivateUserData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeDeactivate
  }
)
export const getListUser = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeList.listUser
  }
)
export const getUser = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeGet.user
  }
)
export const getExportURL = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeExport.url
  }
)
export const getImportResult = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeImport
  }
)
export const getFavoriteMenu = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeFavorite.updatedUser
  }
)
export const getEmployee = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employee || {}
  }
)

export const getKeywordSearch = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employee.keywordSearch
  }
)

export const getCreateMovementData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeCreateMovement
  }
)
export const getEditMovementData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeEditMovement
  }
)
export const getDeleteMovementData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeDeleteMovement
  }
)
export const getEditPrivilegeData = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeEditPrivilege
  }
)

export const isOpenManual = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return employee.employeeManual.isOpen
  }
)

export const redirectEmployee = createSelector(
  employeeSelector,
  employeeImmutable => {
    const employee = employeeImmutable.toJS()
    return ({
      redirect: (employee.employeeCreate.redirect
      || employee.employeeEdit.redirect
      || employee.employeeDeactivate.redirect
      || employee.employeeList.redirect
      || employee.employeeGet.redirect
      || employee.employeeExport.redirect
      || employee.employeeImport.redirect
      || employee.employeeFavorite.redirect),
      isAuthenticated: (employee.employeeCreate.isAuthenticated
      || employee.employeeEdit.isAuthenticated
      || employee.employeeDeactivate.isAuthenticated
      || employee.employeeList.isAuthenticated
      || employee.employeeGet.isAuthenticated
      || employee.employeeExport.isAuthenticated
      || employee.employeeImport.isAuthenticated
      || employee.employeeFavorite.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/employee/employee-selector.js